import type { LucideIcon } from "lucide-react";
import {
  CheckCircle,
  Clock,
  CreditCard,
  FileCheck,
  FileText,
  FileWarning,
  Loader2,
  XCircle,
} from "lucide-react";

type BadgeVariant =
  | "success"
  | "warning"
  | "info"
  | "error"
  | "neutral"
  | "pending";

interface StatusConfig {
  label: string;
  variant: BadgeVariant;
  icon: LucideIcon;
}

const reportStatusMap: Record<string, StatusConfig> = {
  created: { label: "Pendiente", variant: "info", icon: Clock },
  payment_in_progress: {
    label: "Pago Pendiente",
    variant: "pending",
    icon: CreditCard,
  },
  in_progress: { label: "En Progreso", variant: "warning", icon: Loader2 },
  completed: { label: "Completado", variant: "success", icon: CheckCircle },
};

export function getReportStatusConfig(status: string): StatusConfig {
  return (
    reportStatusMap[status] ?? {
      label: status,
      variant: "neutral" as BadgeVariant,
      icon: Clock,
    }
  );
}

const contractStatusMap: Record<string, StatusConfig> = {
  // ---- Real Contract model states (apps/contracts Contract.Status) \u2014 source of truth ----
  created: { label: "Contrato generado", variant: "info", icon: FileCheck },
  payment_in_progress: {
    label: "Pago pendiente",
    variant: "info",
    icon: Clock,
  },
  signature_in_progress: {
    label: "Firma pendiente",
    variant: "info",
    icon: Clock,
  },
  signed: { label: "Firmado", variant: "success", icon: CheckCircle },
  cancelled: { label: "Cancelado", variant: "error", icon: XCircle },
  // ---- Derived / legacy phase + renewal states ----
  draft: { label: "Borrador", variant: "neutral", icon: FileText },
  in_progress: { label: "En progreso", variant: "warning", icon: Loader2 },
  pending_signature: {
    label: "Firma pendiente",
    variant: "info",
    icon: Clock,
  },
  expired: { label: "Vencido", variant: "error", icon: XCircle },
  nearing: { label: "Pr\u00f3ximo a renovar", variant: "warning", icon: Clock },
  active: { label: "Activo", variant: "success", icon: CheckCircle },
};

export function getContractStatusConfig(status: string): StatusConfig {
  return (
    contractStatusMap[status] ?? {
      label: status,
      variant: "neutral" as BadgeVariant,
      icon: FileText,
    }
  );
}

const documentStatusMap: Record<string, StatusConfig> = {
  pending: { label: "Pendiente", variant: "info", icon: Clock },
  uploaded: { label: "Subido", variant: "pending", icon: FileCheck },
  approved: { label: "Aprobado", variant: "success", icon: CheckCircle },
  rejected: { label: "Rechazado", variant: "error", icon: XCircle },
  missing: { label: "Faltante", variant: "warning", icon: FileWarning },
};

export function getDocumentStatusConfig(status: string): StatusConfig {
  return (
    documentStatusMap[status] ?? {
      label: status,
      variant: "neutral" as BadgeVariant,
      icon: FileText,
    }
  );
}
